import React from 'react';
import { cn } from '../../lib/utils';
import type { StatsDisplayProps } from './types';
import styles from './StatsDisplay.module.css';

export function StatsDisplay({ label, value, icon: Icon, className, signatureColor }: StatsDisplayProps) {
  return (
    <div className={cn(styles.container, className)}>
      {Icon && (
        <Icon className={styles.icon} />
      )}
      <div
        className={styles.value}
        style={signatureColor
          ? { color: signatureColor, WebkitTextFillColor: signatureColor }
          : { color: 'var(--signature-color)', WebkitTextFillColor: 'var(--signature-color)' }
        }
      >
        {value}
      </div>
      <div className={styles.label}>
        {label}
      </div>
    </div>
  );
}